import {
  Product as PBProduct,
  Product_Cost as ProductCost,
  Product_TaxStatus,
} from "gen/product/models_pb"

export const taxStatusNames: Record<Product_TaxStatus, string> = {
  [Product_TaxStatus.UNDEFINED]: "Undefined",
  [Product_TaxStatus.NON_TAXABLE]: "Non-taxable",
  [Product_TaxStatus.SINGLE_USE_TAX_EXEMPT]: "Single-use non-taxable",
  [Product_TaxStatus.TAXABLE]: "Taxable",
}

export class Product {
  private product: PBProduct

  private constructor(product: PBProduct) {
    this.product = product
  }

  static fromPB(pbProduct: PBProduct) {
    return new Product(pbProduct)
  }

  get defaultCost(): ProductCost | undefined {
    return this.product.costs.find((cost) => cost.isDefault)
  }

  get taxStatusName(): string {
    return taxStatusNames[this.product.taxStatus]
  }

  get primaryIdentifier(): string {
    return this.product.identifiers[0] ?? ""
  }
}
